import { NgModule } from '@angular/core';

import { MultipleDynamicFormComponent } from 'components/multiple-dynamic-form/multiple-dynamic-form.component';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';

@NgModule({
  imports: [CertemyCommonModule, DynamicFormModule],
  exports: [MultipleDynamicFormComponent],
  declarations: [MultipleDynamicFormComponent],
  providers: [],
})
export class MultipleDynamicFormModule {}
